<template>
  <div>
  <v-data-table
     :headers="headers"
     :items="couriers"
     hide-actions
     class="elevation-1"
     :loading="loading"
   >
     <template slot="items" slot-scope="props">
       <td>{{ props.item.name }}</td>
       <td>{{ props.item.phone }}</td>
       <td><v-icon :color="props.item.online ? 'green' : 'grey'">lens</v-icon></td>
       <td>{{ formatDate(props.item.last_login) }}</td>
       <td class="justify-end layout px-0">
       </td>
     </template>
     <template slot="no-data">
       učitavanje...
     </template>
   </v-data-table>
 </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/sr'
import userService from '@/services/userService'
export default {
  data () {
    return {
      headers: [
        { text: 'ime', value: 'name' },
        { text: 'telefon', value: 'phone' },
        { text: 'aktivan', value: 'active' },
        { text: 'poslednji login', value: 'last_login' },
        { text: '', value: 'actions' }
      ],
      couriers: userService.getCouriers(),
      loading: false
    }
  },
  methods: {
    formatDate (d) {
      return d ? moment(d).format('Do MMMM YYYY, h:mm:ss') : ''
    }
  }
}
</script>

<style scoped>
</style>
